import { Button } from "bootstrap";
import React, { useEffect, useState, useRef } from "react";
import ReactToPrint from "react-to-print";
import { useParams } from "react-router-dom";
import CustomIcons from "../../../components/icons/kIcons.component";
import TextField from "../../../components/inputs/textfield";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import CustomTable from "../../../components/table/table";
import {
  admin_applications_view,
  admin_app_submit,
  admin_status,
  area_allocate_submit,
  clear_financial_record_changes,
} from "../admin.api";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";
import "./view.css";
import moment from "moment";
import * as XLSX from "xlsx";
import AllocateAreaForm from "./Form/form";
import jwtDecode from "jwt-decode";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

export default function View(props) {
  let adminType = Number(jwtDecode(props.state.payload).user_type);
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const [appdata, setAppdata] = useState({});
  const [adminStatus, setadminStatus] = useState({});
  const [printMode, setPrintMode] = useState(false);
  const [count, setCount] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [fileSizeError, setFileSizeError] = useState(false);
  const [showAgreementPopup, setShowAgreementPopup] = useState(false);
  const [agreementFile, setAgreementFile] = useState(null);
  const [agreementRemark, setAgreementRemark] = useState("");
  const [showStartProjectPopup, setShowStartProjectPopup] = useState(false);
  const [startProjectRemarks, setStartProjectRemarks] = useState("");
  const [showCompletedPopup, setShowCompletedPopup] = useState(false);
  const [completionRemarks, setCompletionRemarks] = useState("");

  const [status, setStatus] = useState([
    {
      id: 1,
      status_title: "Submit for Acceptance",
      status_code: "1",
    },
    {
      id: 5,
      status_title: "Revert with Message",
      status_code: "5",
    },
    // {
    //   id: 3,
    //   status_title: "Reject with Reason",
    //   status_code: "2",
    // },
  ]);
  const [snackMessage, setSnackMessage] = useState("");
  const [statusLabel, setstatusLabel] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [formData, setFormData] = useState({});
  const [isActive, setIsActive] = useState(true);
  const [snackOpen, setSnackOpen] = useState(false);

  const { id } = useParams();
  const { id2 } = useParams();
  const [open, setOpen] = useState(false);
  const onSearch = () => {
    //
  };
  const getApplication = () => {
    setIsActive(true);
    admin_applications_view(id)
      .then((res) => {
        setAppdata(res.data);
        setIsActive(false);
        setstatusLabel(res.applicattion_status_label);
      })
      .catch((err) => {
        setIsSnackError(true);
        setIsActive(false);
        setSnackOpen(true);
        setSnackMessage(err.response.data.message);
      });
  };

  useEffect(() => {
    getApplication();
  }, []);
  const handleFormSubmit = (updatedData) => {
    const item = updatedData?.[0] || {};
    // Simple presence validation: Proposed Area and Load Factor must be entered
    if (!item?.allotted_space || !item?.load_factor) {
      setSnackMessage(
        !item?.allotted_space && !item?.load_factor
          ? "Please enter Proposed Area and Load Factor"
          : !item?.allotted_space
            ? "Please enter Proposed Area"
            : "Please enter Load Factor"
      );
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }
    const defaultLeaseYear =
      parseFloat(appdata?.capital_investment || 0) > 99 ? 90 : 30;

    const payload = {
      area_managememt_sub_tables_id: item?.area_managememt_sub_tables_id || "",
      allotted_space: item?.allotted_space || "",
      load_factor: item?.load_factor || "",
      total_area: item?.total_area || "",
      total_amount: item?.total_amount || "",
      years: item?.years || defaultLeaseYear,
      application_id: appdata?.id || "",
      user_id: appdata?.user_id || "",
    };

    console.log("Payload being sent:", payload);

    setIsActive(true);

    area_allocate_submit(payload)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((err) => {
        setSnackMessage(err.response?.data?.message || "An error occurred");
        setIsSnackError(true);
        setIsActive(false);
        setSnackOpen(true);
      });
  };

  const formProps = {
    formvalues: [],
    data: [],
    formData: {},
    initialFormData: {},
    handleFormData: (updatedData) => {
      console.log("Form data:", updatedData);
      setFormData(updatedData);
    },
    handleFormSubmit,
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.history.push(-1);
    }
  };
  const handleChange = (e) => {
    setadminStatus({ ...adminStatus, [e.target.name]: e.target.value });
    setCount(count + 1);
    console.log(adminStatus);
  };
  const handleFileChange = (e) => {
    let file = e.target.files[0];
    if (!file) return;

    let size = file.size;
    let type = file.name.split(".").pop().toLowerCase();
    let mb = size / Math.pow(1024, 2);

    // Check if file is PDF
    if (type !== 'pdf') {
      setFileSizeError(true);
      setSnackMessage("Only PDF files are allowed");
      setIsSnackError(true);
      setSnackOpen(true);
      setadminStatus({
        ...adminStatus,
        file_name: file.name,
      });
      // Clear the file input
      e.target.value = '';
      return;
    }

    // Check if file size is less than 1MB
    if (mb < 1) {
      setFileSizeError(false);
      setadminStatus({
        ...adminStatus,
        file_name: file.name,
        [e.target.name]: file,
      });
    } else {
      setFileSizeError(true);
      setSnackMessage("File size must be less than 1MB");
      setIsSnackError(true);
      setSnackOpen(true);
      setadminStatus({
        ...adminStatus,
        file_name: file.name,
      });
      // Clear the file input
      e.target.value = '';
    }
  };
  const handleAdminStatusUpdate = (e) => {
    e.preventDefault();

    let size = adminStatus?.sample_file?.size || 0;
    let mb = size / Math.pow(1024, 2) || 0;
    if (mb < 1) {
      const form = new FormData();

      form.append("to_user_reject_file_name", adminStatus.file_name ?? null);
      form.append("status_id", adminStatus.status_id ?? null);
      form.append("sample_file", adminStatus.sample_file ?? "");
      if (adminStatus.status_id == 1) {
        form.append("admin_message", adminStatus.message ?? null);
      } else if (adminStatus.status_id == 5) {
        form.append("user_message", adminStatus.message ?? null);
      }

      form.append("application_id", appdata.id ?? null);

      setIsActive(true);
      admin_app_submit(form)
        .then((res) => {
          setSnackMessage(res.message);
          setIsSnackError(false);
          setSnackOpen(true);
          setIsActive(false);
        })
        .catch((err) => {
          setSnackMessage(err.response.data.message);
          setIsSnackError(true);
          setIsActive(false);
          setSnackOpen(true);
        });
    } else {
      setSnackMessage("File size is greater than 1MB");
      setIsSnackError(true);
      setSnackOpen(true);
    }
  };
  const handleClearChanges = (recordId) => {
    setIsActive(true);
    clear_financial_record_changes(recordId)
      .then((res) => {
        setSnackMessage(res.message || "Status cleared successfully");
        setIsSnackError(false);
        setSnackOpen(true);
        getApplication();
      })
      .catch((err) => {
        setSnackMessage(err.response?.data?.message || "An error occurred");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  const handleFinancialRecordsDownload = () => {
    const financialRecords = appdata?.financial_records || [];

    if (!financialRecords.length) {
      setSnackMessage("No financial records available to download");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }

    const exportData = financialRecords.map((record, index) => ({
      "Sl. No": index + 1,
      "Financial Year": record.financial_year || "",
      "Turnover (Cr)": record.fy_turnover || "",
      // "Capital Investment (Cr)": record.capital_investment || "",
      // "Direct Employment": record.direct_emp || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Financial Records");
    XLSX.writeFile(
      workbook,
      `Financial_Records_${moment().format("DD-MM-YYYY_HH-mm-ss")}.xlsx`
    );
  };

  const handleAgrementExecution = (e) => {
    e.preventDefault();
    setShowAgreementPopup(true);
  };

  const handleAgreementSubmit = () => {
    const form = new FormData();

    form.append("agreement_execution_file", agreementFile);
    form.append("status_id", "6");
    form.append("agreement_execution_remarks", agreementRemark);
    form.append("application_id", appdata.id ?? null);

    setIsActive(true);
    admin_app_submit(form)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setShowAgreementPopup(false);
        setAgreementFile(null);
        setAgreementRemark("");
        getApplication();
      })
      .catch((err) => {
        setSnackMessage(err.response?.data?.message || err.message);
        setIsSnackError(true);
        setSnackOpen(true);
      })
      .finally(() => {
        setIsActive(false);
      });
  };

  const handleAgreementCancel = () => {
    setShowAgreementPopup(false);
    setAgreementFile(null);
    setAgreementRemark("");
  };

  const handleOngoing = (e) => {
    e.preventDefault();
    setShowStartProjectPopup(true);
  };

  const handleStartProjectSubmit = () => {
    const form = new FormData();

    form.append("status_id", "7");
    form.append("start_project_remarks", startProjectRemarks);
    form.append("application_id", appdata.id ?? null);

    setIsActive(true);
    admin_app_submit(form)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setShowStartProjectPopup(false);
        setStartProjectRemarks("");
        getApplication();
      })
      .catch((err) => {
        setSnackMessage(err.response?.data?.message || err.message);
        setIsSnackError(true);
        setSnackOpen(true);
      })
      .finally(() => {
        setIsActive(false);
      });
  };

  const handleStartProjectCancel = () => {
    setShowStartProjectPopup(false);
    setStartProjectRemarks("");
  };

  const handleCompleted = (e) => {
    e.preventDefault();
    setShowCompletedPopup(true);
  };

  const handleCompletedSubmit = () => {
    const form = new FormData();

    form.append("status_id", "8");
    form.append("completion_remarks", completionRemarks);
    form.append("application_id", appdata.id ?? null);

    setIsActive(true);
    admin_app_submit(form)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setShowCompletedPopup(false);
        setCompletionRemarks("");
        getApplication();
      })
      .catch((err) => {
        setSnackMessage(err.response?.data?.message || err.message);
        setIsSnackError(true);
        setSnackOpen(true);
      })
      .finally(() => {
        setIsActive(false);
      });
  };

  const handlePrint = () => {
    var originalContents = document.body.innerHTML;
    var printReport = document.getElementById("printable-area").innerHTML;
    document.body.innerHTML = printReport;
    window.print();
    document.body.innerHTML = originalContents;
  };

  const handleDownloadProposal = () => {
    let path = `${result}${appdata.upload_proposal}`;
    window.open(path, "_blank");
  };
  const componentRef = useRef();
  console.log(appdata);
  // const handleDownload = (item) => {
  //   if (!item?.logo) {
  //     alert("No logo available to download.");
  //     return;
  //   }

  //   // Construct the full URL of the logo
  //   let logoPath = `${result}/${item.logo}`; // Ensure `result` contains the base URL

  //   // Create an anchor element dynamically
  //   const link = document.createElement("a");
  //   link.href = logoPath;
  //   link.setAttribute("download", item.logo.split("/").pop()); // Extracts the filename
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  const handleDownload = () => {
    let path = `${result}${appdata.logo}`;
    window.open(path, "_blank");
  };

  const handleDownloadProposalOwn = () => {
    let path = `${result}${appdata.area_management[0]?.proposal_file}`;
    window.open(path, "_blank");
  };
  const flattenedAllocations = appdata.area_allocations?.map((item) => ({
    ...item,
    location: item.area_sub_table?.location?.locations ?? "",
    sub_location: item.area_sub_table?.sub_location ?? "",
    built_space_type_name: item.area_sub_table?.built_space_type?.name ?? "",
    category: item.area_sub_table?.built_space_type ? "Built-up Space" : "Land",
  }));

  return (
    <div>
      <Loader open={isActive} />
      <div className="view-container">
        <div className="col-12 d-flex justify-content-end ">
          <ReactToPrint
            onBeforePrint={() => setPrintMode(true)}
            onAfterPrint={() => setPrintMode(false)}
            trigger={() => (
              <button
                type="button"
                className="btn btn-warning1 btn-sm mr-2 mb-2 dwnlded"
              >
                <CustomIcons iconName="download" iconClass="down" />
                Download info
              </button>
            )}
            content={() => componentRef.current}
          />
          <button
            type="button"
            onClick={(e) => handleDownloadProposal()}
            className="btn btn-success ml-2 btn-sm mb-2 "
          >
            <CustomIcons iconName="download" iconClass="down" />
            Download Proposal
          </button>
        </div>
        <form onSubmit={handleAdminStatusUpdate}>
          <div ref={componentRef} className={printMode ? "p-2" : "p-4"}>
            <div className="d-flex justify-content-between">
              <h6>
                <b>New Company Request</b>
              </h6>
              <button
                type="button"
                className="btn btn-primary"
                onClick={(e) => {
                  id2 == "kspace"
                    ? props.history.push("/company-request-list/kspace")
                    : props.history.push("/company-request-list/own");
                }}
              >
                Back
              </button>
            </div>
            <hr />

            <div className="data">
              <div className="row">
                <div className="col-3">Company Name</div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.company_name ?? ""}</div>
              </div>
              <div className="row">
                <div className="col-3">Application ID</div>
                <div className="col-1">:</div>
                <div className="col-7">
                  {appdata.unique_application_ref_no ?? ""}
                </div>
              </div>
              <div className="row">
                <div className="col-3">Contact Person Name</div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.person_name ?? ""}</div>
              </div>
              <div className="row">
                <div className="col-3">Contact Person Designation</div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.person_designation}</div>
              </div>
              <div className="row">
                <div className="col-3">Primary Mail Id</div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.email ?? ""}</div>
              </div>
              <div className="row">
                <div className="col-3">Primary Contact No</div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.phone_no ?? ""}</div>
              </div>
              {appdata.site_link && (
                <div className="row">
                  <div className="col-3">Website Link</div>
                  <div className="col-1">:</div>
                  <div className="col-7">{appdata.site_link ?? ""}</div>
                </div>
              )}
              {appdata.logo && (
                <div className="row">
                  <div className="col-3">Company Logo</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    {/* <a
                  style={{ cursor: "pointer" }}
                  onClick={(e) => handleDownload(appdata)}
                >
                  <b>Download Logo</b>
                </a> */}
                    <button
                      type="button"
                      onClick={(e) => handleDownload(appdata)}
                      className="btn btn-reject btn-dark btn-sm"
                    >
                      Download Logo
                    </button>
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-3">Address</div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.address ?? ""}</div>
              </div>
              {appdata.alternate_email && (
                <div className="row">
                  <div className="col-3">Alternate Mail Id</div>
                  <div className="col-1">:</div>
                  <div className="col-7">{appdata.alternate_email ?? ""}</div>
                </div>
              )}
              {appdata.alternate_phone && appdata.country_code && (
                <div className="row">
                  <div className="col-3">Alternate Contact No</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    {appdata.alternate_phone && (
                      <>
                        {appdata.country_code &&
                          appdata.country_code !== "" &&
                          appdata.country_code !== "undefined" &&
                          appdata.country_code !== "null" && (
                            <>
                              {appdata.country_code ?? ""}{" "}
                              {appdata.country_code &&
                                appdata.country_code !== ""
                                ? "-"
                                : ""}{" "}
                            </>
                          )}
                      </>
                    )}
                    {appdata.alternate_phone ?? ""}
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-3">New company / Existing company ?</div>
                <div className="col-1">:</div>
                <div className="col-7">
                  {" "}
                  {appdata.company_status === "new_company"
                    ? "New Company"
                    : appdata.company_status === "existing_company"
                      ? "Existing Company"
                      : ""}
                </div>
              </div>
              {appdata?.financial_records?.length > 0 && (
                <>
                  <div className="row mt-4">
                    <div className="col-12 d-flex align-items-start justify-content-between">
                      <div>
                        <p className="mb-0" style={{ fontWeight: 700, fontSize: "15px" }}><b>Financial Records</b></p>
                        <p className="text-muted small mt-1">Review the financial history and recent changes for this application.</p>
                      </div>
                      <button
                        type="button"
                        className="financial-download-btn"
                        title="Download financial records"
                        onClick={handleFinancialRecordsDownload}
                      >
                        <CustomIcons iconName="download" iconClass="down" />
                      </button>
                    </div>
                  </div>
                  <hr />
                  <div className="table-responsive">
                    <table className="table table-bordered financial-table">
                      <thead className="thead-light">
                        <tr>
                          <th>Financial Year</th>
                          <th>Turnover (Cr)</th>
                          {/* <th>Capital Investment (Cr)</th> */}
                          {/* <th>Male Employment</th>
                          <th>Female Employment</th>
                          <th>Others</th>
                          <th>SC/ST</th>
                          <th>PWD</th>
                          <th>Direct Emp</th> */}
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {appdata.financial_records.map((record, index) => {
                          const status = record.financial_records_changed || "neutral";
                          const lastRecord = record.last_record ? JSON.parse(record.last_record) : null;

                          const renderVal = (field) => {
                            if (status === "updated" && lastRecord && lastRecord[field] !== undefined && String(lastRecord[field]) !== String(record[field])) {
                              return (
                                <div className="value-diff">
                                  <span className="old-val">{lastRecord[field]}</span>
                                  <span className="diff-arrow">→</span>
                                  <span className="new-val">{record[field]}</span>
                                </div>
                              );
                            }
                            return record[field];
                          };

                          return (
                            <tr key={record.id || index} className={`record-row-${status}`}>
                              <td><b>{record.financial_year}</b></td>
                              <td>{renderVal("fy_turnover")}</td>
                              {/* <td>{renderVal("capital_investment")}</td> */}
                              {/* <td>{renderVal("dir_employ_male")}</td>
                              <td>{renderVal("dir_employ_female")}</td>
                              <td>{renderVal("dir_employ_others")}</td>
                              <td>{renderVal("dir_employ_sc_st")}</td>
                              <td>{renderVal("dir_employ_pwd")}</td>
                              <td>{renderVal("direct_emp")}</td> */}
                              <td>
                                <div className="d-flex align-items-center justify-content-center">
                                  {status !== "neutral" && status !== "cleared" && (
                                    <button
                                      type="button"
                                      className="btn-clear-status"
                                      title={`Clear ${status} status`}
                                      onClick={() => handleClearChanges(record.id)}
                                    >
                                      <CustomIcons iconName="tick" />
                                    </button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  {appdata?.financial_records?.length > 0 && (
                    <div className="mt-4">
                      <p className="mb-0" style={{ fontWeight: 700, fontSize: "15px", marginLeft: "16px" }}><b>Financial Records Chart</b></p>
                      <ResponsiveContainer width="100%" height={300}>
                        <BarChart
                          data={appdata.financial_records
                            .map(r => ({
                              financial_year: r.financial_year,
                              turnover: Number(r.fy_turnover) || 0,
                            }))
                            .sort((a, b) => a.financial_year.localeCompare(b.financial_year))}
                          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="financial_year" />
                          <YAxis />
                          <Tooltip />
                          <Legend />
                          <Bar dataKey="turnover" fill="#0A223D" name="Turnover (Cr)" barSize={40} />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  )}
                </>
              )}

              <div className="row">
                <div className="col-3">
                  Capital Investment Expected in Crores
                </div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.capital_investment ?? ""}</div>
              </div>
              <div className="row">
                <div className="col-3">Initial Direct Employment</div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.ex_man_power ?? ""}</div>
              </div>
              <div className="row">
                <div className="col-3">Abstract Project Proposal</div>
                <div className="col-1">:</div>
                <div className="col-7">
                  {appdata.abstract_project_proposal ?? ""}
                </div>
              </div>
              <div className="row">
                <div className="col-3">Product Profile</div>
                <div className="col-1">:</div>
                <div className="col-7">
                  {appdata?.product_profiles?.map((item, i) => (
                    <div key={i}>
                      <div className="col-12 mb-1">
                        <b>{item.product_name ?? ""}</b>
                      </div>
                      <div className="col-12 mb-2 ">
                        <div>{ReactHtmlParser(item.product_desc)}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="row">
                <div className="col-3">Domain Type</div>
                <div className="col-1">:</div>
                <div className="col-7">
                  {appdata?.domain_types?.map((dom, i) => (
                    <div key={i}>{dom.domain_name}</div>
                  ))}
                  {(appdata?.any_other_flag == 1 ||
                    (appdata?.any_other_domain &&
                      appdata?.any_other_domain != null)) && (
                      <div>{appdata?.any_other_domain}</div>
                    )}

                  <></>
                </div>
              </div>
              {/* <div className="row">
                <div className="col-3">Any Other Domain</div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.any_other_domain ?? ""}</div>
              </div> */}

              {/* <div className="row">
                <div className="col-3">Document Uploaded</div>
                <div className="col-1">:</div>
                <div className="col-7 ">{appdata?.file_name}</div>
              </div> */}
            </div>
            {appdata?.upload_proposal && (
              <div className="data">
                <div className="row mt-3">
                  <div className="col-3">Project Proposal</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={(e) => handleDownloadProposal()}

                    >
                      Download Proposal
                    </button>
                  </div>
                </div>
              </div>
            )}

            {appdata.area_type && (
              <h6>
                <b>Area Requirements</b>
              </h6>
            )}
            <hr />
            <div className="data">
              {appdata.area_type === "built_up_space" && (
                <div className="row">
                  <div className="col-3">
                    Requested <br></br> Built-up space on Rent per Month
                  </div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    <CustomTable
                      className="areatable"
                      {...props}
                      columns={[
                        { title: "Preference No", field: "id", type: "dynId" },
                        { title: "Location", field: "location" },
                        { title: "Sub Location", field: "sub_location" },
                        {
                          title: "Category",
                          field: "area_type",
                          render: (rowData) =>
                            rowData.area_type === "built_up_space"
                              ? "Built-up Space"
                              : "Land",
                        },
                        {
                          title: "Built-Up Space Category",
                          field: "built_space_type",
                        },
                        {
                          title: "Rentable Area(in sqft)",
                          field: "available_area",
                        },
                        {
                          title: "Area Requirement (Requested area in sqft)",
                          field: "area_in_sqft",
                        },

                        // {
                        //   title: "Investment model",
                        //   field: "investment_model",
                        // },
                        // { title: "Management plan", field: "management_plan" },
                      ]}
                      data={appdata?.area_management}
                    />
                  </div>
                </div>
              )}
              {appdata.area_type === "equipped_facility" && (
                <div className="row">
                  <div className="col-3">Equipped Facility per Month </div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    <CustomTable
                      className="areatable"
                      {...props}
                      columns={[
                        { title: "Preference No", field: "id", type: "dynId" },
                        { title: "Location", field: "location" },

                        {
                          title: "Requested Area Requirement",
                          field: "area_in_sqft",
                        },
                        {
                          title: "Rentable Area(in sqft)",
                          field: "available_area",
                        },
                      ]}
                      data={appdata?.area_management}
                    />
                  </div>
                </div>
              )}
              {appdata.area_type === "land_on" && (
                <div className="row">
                  <div className="col-3">Requested Land on Lease</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    <CustomTable
                      className="areatable"
                      {...props}
                      columns={[
                        { title: "Preference No", field: "id", type: "dynId" },
                        { title: "Location", field: "location" },
                        { title: "Sub Location", field: "sub_location" },
                        {
                          title: "Category",
                          field: "area_type",
                          render: (rowData) =>
                            rowData.area_type === "built_up_space"
                              ? "Built-up Space"
                              : "Land On Lease",
                        },
                        {
                          title: "Land Requirement(in cents)",
                          field: "area_in_acres",
                        },
                        // { title: "Address", field: "land_address" },

                        { title: "Lease Years", field: "lease_year" },
                        {
                          title: "Rentable Area",
                          field: "available_area",
                        },
                      ]}
                      data={appdata?.area_management}
                    />
                  </div>
                </div>
              )}
              {appdata.area_type === "joint_venture" && (
                <div className="row">
                  <div className="col-3">
                    Requested <br></br>Joint Venture
                  </div>
                  <div className="col-1">:</div>
                  <div className="col-7 venure">
                    <CustomTable
                      className="areatable"
                      {...props}
                      columns={[
                        { title: "Preference No", field: "id", type: "dynId" },
                        { title: "Location", field: "location" },
                        { title: "Sub Location", field: "sub_location" },
                        {
                          title: "Category",
                          field: "area_management_id",
                          render: (rowData) =>
                            rowData.area_management_id == 1
                              ? "Built-up Space"
                              : "Land",
                        },
                        ...(appdata?.area_management?.some(
                          (row) => row.area_management_id == 1
                        )
                          ? [
                            {
                              title: "Area Type",
                              field: "built_space_type",
                            },
                          ]
                          : []),
                        {
                          title: "Request Area",
                          render: (rowData) =>
                            rowData.area_management_id == 1
                              ? `${rowData.area_in_sqft ?? 0} Sq.ft`
                              : `${rowData.area_in_acres ?? 0} Cents`,
                        },
                        ...(appdata?.area_management?.some(
                          (row) => row.area_management_id != 1
                        )
                          ? [{ title: "Lease Years", field: "lease_year" }]
                          : []),
                        {
                          title: "Investment Model",
                          field: "investment_model",
                        },
                        { title: "Management Plan", field: "management_plan" },
                      ]}
                      data={appdata?.area_management}
                    />
                  </div>
                </div>
              )}
              {appdata.area_type === "own_land" && (
                <div className="row">
                  <div className="col-3">
                    Requested <br></br>Own Premises{" "}
                  </div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    <CustomTable
                      className="areatable"
                      {...props}
                      columns={[
                        { title: "Location", field: "location" },
                        { title: "Sub Location", field: "sub_location" },
                        { title: "Available Area", field: "area_in_sqft" },
                        { title: "Survey Number", field: "survey_no" },
                        { title: "Block Number", field: "block_no" },
                        { title: "Village Name", field: "village_name" },
                        { title: "Address of Property", field: "land_address" },
                        { title: "Management Plan", field: "management_plan" },
                        {
                          title: "Nature Of Holding",
                          field: "nature_of_holding",
                        },
                        {
                          title: "Interest in JV",
                          render: (rowData) =>
                            rowData.proposal_file ? "Yes" : "No",
                        },
                      ]}
                      data={appdata?.area_management}
                    />
                  </div>
                </div>
              )}
              {appdata.area_management?.[0]?.proposal_file != null &&
                appdata.area_type === "own_land" && (
                  <div className="row">
                    <div className="col-3">
                      Interested in Joint venture with KSPACE
                    </div>
                    <div className="col-1">:</div>
                    <div className="col-7">
                      {/* <a
                  style={{ cursor: "pointer" }}
                  onClick={(e) => handleDownload(appdata)}
                >
                  <b>Download Logo</b>
                </a> */}
                      <button
                        type="button"
                        onClick={(e) => handleDownloadProposalOwn(appdata)}
                        className="btn btn-reject btn-dark btn-sm"
                      >
                        Download Proposal
                      </button>
                    </div>
                  </div>
                )}
              {appdata.area_type !== "own_land" &&
                appdata.area_type !== "joint_venture" && (
                  <>
                    {/* {(appdata.application_status === 0 ||
                      appdata.application_status === 3) && ( */}
                    <div className="row mt-3">
                      <div className="col-3">Allocate</div>
                      <div className="col-1">:</div>
                      <div className="col-7">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => setShowModal(true)}
                        >
                          Click here
                        </button>
                      </div>
                    </div>
                    {/* )} */}
                  </>
                )}

              {appdata.area_type !== "own_land" && (
                <>
                  {appdata.area_allocations &&
                    (appdata.area_allocations.length > 0 &&
                      <div className="row mt-3">
                        <div className="col-3">Allotted</div>
                        <div className="col-1">:</div>
                        <div className="col-7">
                          <CustomTable
                            className="areatable"
                            {...props}
                            columns={[
                              {
                                title: "Location",
                                field: "location",
                              },
                              {
                                title: "Sub Location",
                                field: "sub_location",
                              },
                              {
                                title: "Category",
                                field: "category",
                              },
                              ...(flattenedAllocations.some(
                                (row) => row.category === "Built-up Space"
                              )
                                ? [
                                  {
                                    title: "Built-Up Space Category",
                                    field: "built_space_type_name",
                                  },
                                ]
                                : []),
                              ...(flattenedAllocations.some(
                                (row) => row.category === "Land"
                              )
                                ? [
                                  {
                                    title: "Lease Years",
                                    field: "years",
                                  },
                                ]
                                : []),
                              {
                                title: "Load Factor",
                                field: "load_factor",
                              },
                              {
                                title: "Area Allotted",
                                field: "allotted_space",
                              },
                              {
                                title: "Total Rent (Rupees/month)",
                                field: "total_amount",
                              },

                            ]}
                            data={flattenedAllocations}
                          />
                        </div>
                      </div>
                    )}
                </>
              )}
              <div className="nio row ">
                <div className="col-3 ">Current Application Status</div>
                <div className="col-1">:</div>
                <div className="col-7 blink_me1">
                  {appdata?.application_status === 0
                    ? "Pending"
                    : appdata?.application_status == 1
                      ? "Submitted for acceptance"
                      : appdata?.application_status == 2
                        ? "Approved"
                        : appdata?.application_status == 3
                          ? "Super Admin Reverted"
                          : appdata?.application_status == 4
                            ? "Rejected"
                            : appdata?.application_status == 5
                              ? "Admin Reverted"
                              : appdata?.application_status == 6
                                ? "Agreement Execution"
                                : appdata?.application_status == 7
                                  ? "Ongoing Project"
                                  : appdata?.application_status == 8
                                    ? "Completed"
                                    : appdata?.application_status == 15
                                      ? "Company Suggestion"
                                      : appdata?.application_status == 16
                                        ? "Waiting for Company Approval"

                                        : "Agreement Execution"}
                </div>
              </div>
              <div className="row">
                <div className="col-3">Created At</div>
                <div className="col-1">:</div>
                <div className="col-7">
                  {appdata.created_at
                    ? moment(appdata.created_at).format("DD-MM-YYYY")
                    : ""}
                </div>
              </div>
              {appdata?.to_super_admin_message_content &&
                appdata?.to_super_admin_message_content !== "" && (
                  <div className="row">
                    <div className="col-3">Message from Super Admin</div>
                    <div className="col-1">:</div>
                    <div className="col-7 ">
                      {appdata?.to_super_admin_message_content}
                    </div>
                  </div>
                )}
            </div>
          </div>
          {(appdata.application_status === 0 ||
            appdata.application_status === 3) &&
            adminType !== 23 && (
              <div className="px-4">
                {status?.length !== 0 && (
                  <>
                    <div className="col-6 mt-3 status">
                      <label>
                        <b>Select Action</b>
                      </label>
                      <select
                        className="form-select mt-2"
                        aria-label="Default select example"
                        onChange={handleChange}
                        name="status_id"
                        required
                        value={adminStatus.status_id}
                      >
                        <option value="">Select Action</option>
                        {status?.map((item, i) => (
                          <>
                            {!item.hidden && (
                              <option value={item.id} key={i}>
                                {item.status_title}
                              </option>
                            )}
                          </>
                        ))}
                      </select>
                    </div>

                    {(appdata.application_status === 0 ||
                      appdata.application_status === 3) && (
                        <div className="col-6 mt-3">
                          <div className="form-group">
                            {/* <label for="exampleFormControlTextarea1">Example textarea</label> */}
                            <textarea
                              className="form-control"
                              id="exampleFormControlTextarea1"
                              placeholder="Message.."
                              rows="3"
                              required={
                                adminStatus.sample_file === null ||
                                  adminStatus.sample_file === undefined ||
                                  adminStatus.sample_file === ""
                                  ? true
                                  : false
                              }
                              onChange={handleChange}
                              name="message"
                              value={adminStatus.message}
                            ></textarea>
                          </div>
                        </div>
                      )}
                    {(appdata.application_status === 0 ||
                      appdata.application_status === 3) && (
                        <div className="col-6 mb-01 mt-3">
                          {adminStatus.status_id == 5 && (
                            <>
                              <TextField
                                name="file_name"
                                type="file"
                                required={
                                  adminStatus.message === null ||
                                    adminStatus.message === undefined ||
                                    adminStatus.message === ""
                                    ? false
                                    : false
                                }
                                variant="outlined"
                                onChange={handleFileChange}
                              // accept=".pdf,.doc"
                              />
                              {fileSizeError && (
                                <small className="indicator text-danger">
                                  Size should be less than 1MB
                                </small>
                              )}
                            </>
                          )}
                          {/* <Button className="btn btn-danger">Clear File</Button> */}
                        </div>
                      )}
                  </>
                )}

                {status?.length !== 0 && (
                  <button type="submit" className="btn mb-2 mysubbtn">
                    Submit
                  </button>
                )}
              </div>
            )}
          {appdata.application_status === 2 && adminType !== 23 && (
            <div className="d-flex justify-content-center">
              <button
                onClick={(e) => handleAgrementExecution(e)}
                className="btn mb-2 mysubbtn"
              >
                Agreement Execution
              </button>
            </div>
          )}
          {appdata.application_status === 6 && adminType !== 23 && (
            <div className="d-flex justify-content-center">
              <button
                onClick={(e) => handleOngoing(e)}
                className="btn mb-2 mysubbtn"
              >
                Start Project
              </button>
            </div>
          )}
          {appdata.application_status === 7 && adminType !== 23 && (
            <div className="d-flex justify-content-center">
              <button
                onClick={(e) => handleCompleted(e)}
                className="btn mb-2 mysubbtn"
              >
                Completed
              </button>
            </div>
          )}
        </form>
      </div>
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      {showModal && (
        <div className="modal-custom-overlay">
          <div className="modal-custom-container">
            <div className="modal-custom-header">
              <h5>Allocate Area</h5>
              <button
                type="button"
                className="modal-custom-close"
                onClick={() => setShowModal(false)}
              >
                ×
              </button>
            </div>
            <div className="modal-custom-content">
              <AllocateAreaForm
                {...formProps}
                appdata={appdata}
                setAppdata={setAppdata}
                onSubmit={handleFormSubmit} // pass submit handler here
                formId="allocateAreaForm"
              />
            </div>
            <div className="modal-custom-footer">
              <button
                type="button"
                className="btn-custom-secondary"
                onClick={() => setShowModal(false)}
              >
                Close
              </button>
              <button
                type="submit" // Change to submit type
                className="btn-custom-primary"
                form="allocateAreaForm"
                onClick={() => {
                  handleFormSubmit(formData); // manually pass current state
                  setShowModal(false); // close modal
                }}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}
      {showAgreementPopup && (
        <div className="overlay">
          <div className="big-dia1 dialog1" style={{ height: "480px" }}>
            <Snackbar
              message={snackMessage}
              error={isSnackError}
              open={snackOpen}
              close={snackbarClose}
            />
            <div className="row">
              <div className="flexDisplay">
                <div className="diaTitleCon1 " style={{ fontSize: "24px" }}>
                  Agreement Execution
                </div>
                <div className="dia-close" onClick={handleAgreementCancel}>
                  <div className="diaCloseCon">
                    <div className="diaClose">&#10005;</div>
                  </div>
                </div>
              </div>
              <div className="tilebar">
                <hr />
              </div>

              <div className="book-form">
                <div className="col-12">
                  <label className="form-label" style={{ fontSize: "15px" }}>
                    Upload Agreement File <span className="text-danger ">*</span>
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        const maxSize = 2 * 1024 * 1024;
                        if (file.size > maxSize) {
                          setSnackMessage("File size must be less than 2 MB");
                          setIsSnackError(true);
                          setSnackOpen(true);
                          e.target.value = "";
                          return;
                        }
                        setAgreementFile(file);
                      }
                    }}
                    accept=".pdf,.doc,.docx"
                    required
                    style={{ border: "1px solid #9ca3af" }}
                  />
                  <small className="text-muted">Accepted formats: PDF, DOC, DOCX</small>
                </div>

                <div className="col-12 mt-3">
                  <label className="form-label" style={{ fontSize: "15px" }}>
                    Remark <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows="4"
                    value={agreementRemark}
                    onChange={(e) => setAgreementRemark(e.target.value)}
                    placeholder="Enter your remarks here..."
                    required
                    style={{ border: "1px solid #9ca3af" }}
                  />
                </div>

                <div className="col-12 mt-4">
                  <div className="d-flex justify-content-center gap-2">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      style={{ minWidth: "120px" }}
                      onClick={handleAgreementCancel}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      style={{ minWidth: "120px" }}
                      onClick={handleAgreementSubmit}
                      disabled={!agreementFile || !agreementRemark.trim()}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showCompletedPopup && (
        <div className="overlay">
          <div className="big-dia1 dialog1" style={{ height: "360px" }}>
            <Snackbar
              message={snackMessage}
              error={isSnackError}
              open={snackOpen}
              close={snackbarClose}
            />
            <div className="row">
              <div className="flexDisplay">
                <div className="diaTitleCon1" style={{ fontSize: "24px" }}>Completed</div>
                <div
                  className="dia-close"
                  onClick={() => {
                    setShowCompletedPopup(false);
                    setCompletionRemarks("");
                  }}
                >
                  <div className="diaCloseCon">
                    <div className="diaClose">&#10005;</div>
                  </div>
                </div>
              </div>
              <div className="tilebar">
                <hr />
              </div>

              <div className="book-form">
                <div className="col-12">
                  <label className="form-label" style={{ fontSize: "15px" }}>
                    Completion Remarks <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows="4"
                    value={completionRemarks}
                    onChange={(e) => setCompletionRemarks(e.target.value)}
                    placeholder="Enter completion remarks here..."
                    required
                    style={{ border: "1px solid #9ca3af" }}
                  />
                </div>

                <div className="col-12 mt-4">
                  <div className="d-flex justify-content-center gap-2">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      style={{ minWidth: "120px" }}
                      onClick={() => {
                        setShowCompletedPopup(false);
                        setCompletionRemarks("");
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      style={{ minWidth: "120px" }}
                      onClick={handleCompletedSubmit}
                      disabled={!completionRemarks.trim()}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showStartProjectPopup && (
        <div className="overlay">
          <div className="big-dia1 dialog1" style={{ height: "350px" }}>
            <Snackbar
              message={snackMessage}
              error={isSnackError}
              open={snackOpen}
              close={snackbarClose}
            />
            <div className="row">
              <div className="flexDisplay">
                <div className="diaTitleCon1" style={{ fontSize: "24px" }}>
                  Start Project
                </div>
                <div className="dia-close" onClick={handleStartProjectCancel}>
                  <div className="diaCloseCon">
                    <div className="diaClose">&#10005;</div>
                  </div>
                </div>
              </div>
              <div className="tilebar">
                <hr />
              </div>

              <div className="book-form">
                <div className="col-12">
                  <label className="form-label" style={{ fontSize: "15px" }}>
                    Remarks <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows="4"
                    value={startProjectRemarks}
                    onChange={(e) => setStartProjectRemarks(e.target.value)}
                    placeholder="Enter your remarks here..."
                    required
                    style={{ border: "1px solid #9ca3af" }}
                  />
                </div>

                <div className="col-12 mt-4">
                  <div className="d-flex justify-content-center gap-2">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      style={{ minWidth: "120px" }}
                      onClick={handleStartProjectCancel}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      style={{ minWidth: "120px" }}
                      onClick={handleStartProjectSubmit}
                      disabled={!startProjectRemarks.trim()}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
